import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import {
  getProductDefaultInfo,
  getProductSmallInfo,
} from '../../../../utilities/selectors';
import { StockInfo } from '../../Product/StockInfo';
import { ProductPriceCartTable } from '../../Product/ProductPriceCartTable';
import {
  FlexCol,
  FlexRowCenterHorizontal,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { FormInput } from '../../Form/FormInput';
import { getSymbolFromCurrency } from '../../../../utilities';
import { __ } from 'react-i18n';
import {
  getElasticCategoryZemplinProductInfo,
  getZemplinProductDefaultInfo,
  getZemplinTrueCountFromNormalCount,
} from '../../../Zemplin/selectors';
import { PriceInfo } from '../../../Zemplin/ProductDetail/PriceInfo';

export interface Props {
  product: any;
  count: number;
  isRequest: boolean;
  isLoggedIn: boolean;
  isFromCategory: boolean;
}

function AddedToCartProduct({
  product,
  count,
  isRequest,
  isLoggedIn,
  isFromCategory,
}: Props) {
  const { currency } = getProductDefaultInfo(product);
  const { name } = getProductDefaultInfo(product);
  const { picture } = getProductSmallInfo(product);
  const {
    unit,
    price,
    priceWithoutVat,
    productPackages,
    unpackingCost,
    unpackingCostWithoutVat,
  } = getZemplinProductDefaultInfo(product);
  const truePrice = isLoggedIn ? priceWithoutVat : price;
  const priceWithCount = truePrice ? (truePrice * count).toFixed(2) : '';

  return (
    <Wrapper>
      <FlexRowCenterVertical>
        <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
        <NameWrapper>
          <Name>{name}</Name>
          <Package>{`${count} ${unit}`}</Package>
        </NameWrapper>
      </FlexRowCenterVertical>
      {!isRequest && (
        <div>
          <PriceInfo
            price={priceWithCount ? priceWithCount : 0}
            currency={currency}
            text={isLoggedIn ? __('Spolu bez DPH') : __('Spolu s DPH')}
          />
        </div>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  width: 100%;

  ${({ theme }) => theme.mediab.m600`
    flex-flow: column;
    align-items: flex-start;
    margin-bottom: 0;
  `}
`;

const NameWrapper = styled(FlexCol)`
  ${({ theme }) => theme.mediab.m600`
   width: 65%;
  `}
`;

const Image = styled.img`
  width: ${rem(80)};
  height: ${rem(80)};
  margin-right: ${rem(24)};
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(4)};

  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 400;
  max-width: ${rem(300)};
  transition: color 0.2s;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-left: ${rem(8)};
`;

const Package = styled(Price)`
  margin-left: 0;
  color: ${({ theme }) => theme.colors.placeholder};
`;

export { AddedToCartProduct };
